import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { CatalogoService } from 'src/app/services/catalogo.service';
import { myDatePickerOptions } from 'src/app/services/url.servicios';
import { HistorialService } from 'src/app/services/historial.service';

@Component({
  selector: 'app-form-esccz',
  templateUrl: './form-esccz.component.html',
  styles: []
})
export class FormESCCZComponent implements OnInit {

  myDatePickerOptions = myDatePickerOptions;
  placeholder_1: String = 'Fecha';
  total = 3;
  pagina = 1;
  data = [];
  backup = [];
  result = [];
  seleccionado: { Cat_Escalas_Id: number, Fecha: any, Puntaje: number, Observaciones: string } = { Cat_Escalas_Id: 0, Fecha: undefined, Puntaje: 0, Observaciones: '' };

  constructor(
    public _catalogoSrv: CatalogoService,
    public _historialSrv: HistorialService
  ) {
    this.paginador();
  }

  ngOnInit() {
  }

  paginador() {
    this.data.forEach(element => {
      let x = this.backup.find(x => x.Id === element.Id);
      if (x) {
        x.Puntaje = element.Puntaje;
      } else {
        this.backup.push(element);
      }
    });

    this._catalogoSrv.escalas_detalle('ESCCZ', this.pagina, 13)
      .then((data: any[]) => {
        this.data = [];
        this.data.push(...data);
        this.recargar();
      });

    this._historialSrv.escalas(1, 2, 1, 12)
      .then((data: any[]) => {
        this.result = [];
        this.result.push(...data);

        // this.recargar();
      });
  }

  recargar() {
    this.data.forEach(element => {
      let x = this.backup.find(x => x.Id === element.Id);
      if (x) {
        element.Puntaje = x.Puntaje;
      } else if (element.Familiar > 0) {
        this.backup.push(element);
      }
    });

    this.seleccionado.Puntaje = 0;
    this.backup.forEach(element => {
      this.seleccionado.Puntaje += Number(element.Puntaje);
    });
  }

  guardar(forma: NgForm) {
    this.seleccionado.Cat_Escalas_Id = 2;
    this.seleccionado.Fecha = this.seleccionado.Fecha.formatted;

    this._historialSrv.insertar_escala(this.seleccionado)
      .then(() => {
        this.seleccionado = { Cat_Escalas_Id: 0, Fecha: null, Puntaje: 0, Observaciones: '' };
        this.backup = [];
        this.paginador();
      });
  }

  validar(forma: NgForm): boolean {
    return forma.invalid;
  }

  prevPaginado(pagina: number) {
    if (this.pagina - pagina < 1) {
      this.pagina = 1;
    } else {
      this.pagina = this.pagina - pagina;
    }
    this.paginador();
  }

  nextPaginado(pagina: number) {
    if (this.pagina + pagina > this.total) {
      this.pagina = this.total;
    } else {
      this.pagina = this.pagina + pagina;
    }
    this.paginador();
  }

}
